import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { Calendar } from '@/components/Calendar'
import { formatDate } from '@/utils/dateUtilities'
import upperFirst from 'lodash/upperFirst'

class EditSubmissionDateDialog extends React.Component {
  dateValue () {
    return this.props.submission[this.props.editedDate]
  }
  formatTitle () {
    const dateType = this.props.localize(`Reporting.${upperFirst(this.props.editedDate)}`)
    return `${dateType} - ${formatDate(this.dateValue())}`
  }
  render () {
    return (
      <React.Fragment>
        <BasicHeader localizedTitle={this.formatTitle()} {...this.props} />
        <ModalBody>
          <Calendar value={this.dateValue()} onChange={e => this.props.onAction(e.value)} />
        </ModalBody>
      </React.Fragment>
    )
  }
}

export default {
  component: EditSubmissionDateDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/submissionDate.js